export enum SLADurationType {
	Hours = 0,
	Days = 1,
	// Weeks = 2,
	// Months = 3,
	// Years = 4,
}
